module.exports = tvg.deps["react-dom"]["react-dom-18"];